@if (application(); as application) {
  <div class='application-details'>
    <div class='row'>
      <div class='col-md-3'>
        <app-label label='Data utworzenia:'>
          {{ application?.createdAt | date }}
        </app-label>
      </div>
      <div class='col-md-3'>
        <app-label label='Data zatwierdzenia:'>
          {{ application?.updatedAt | date }}
        </app-label>
      </div>
      <div class='col-md-6'>
        <app-label label='Numer sprawy:'>
          {{ application?.caseNumber || '-' }}
        </app-label>
      </div>
    </div>
    <ng-container *ngIf='shipments()?.length'>
      <br>
      <app-decision-data-preview [canPay]='canPay()' [shipments]='shipments()'>
      </app-decision-data-preview>
      <br>
    </ng-container>
    <app-applicant-preview
      [application]='application'
      [expanded]='expanded'>
    </app-applicant-preview>
    <br>
    <h3>
      Dane wniosku
    </h3>
    <app-application-data-preview [application]='application'>
    </app-application-data-preview>
    <br>
    <h3>
      Zażalenie
    </h3>
    <div class="row">
      <div class='col-md-4'>
        <app-label label='Data wydania decyzji:'>
          {{ application?.decisionDate | date }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='Data otrzymania decyzji:'>
          {{ application?.decisionDeliveryDate | date }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Zaskarżenie dotyczy:">
          {{ application?.appealSubjectDescription || application?.appealSubject || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Wnoszę o:">
          {{ application?.appealRequestDescription || application?.appealRequest || '-' }}
        </app-label>
      </div>
    </div>
    <dl class="mb-4">
      <dt class="mb-2">
        <strong>
          Powód zaskarżenia
        </strong>
      </dt>
      <dd>
        <div class="row">
          <div class="col-12">
            <app-label label="Naruszenie przepisów prawa procesowego:">
              {{ application?.appealGroundLegalBreach || '-' }}
            </app-label>
            <br>
            <app-label label="Nowe okoliczności faktyczne:">
              {{ application?.appealGroundNewFacts || '-' }}
            </app-label>
          </div>
        </div>
      </dd>
    </dl>
    <h3>
      Zgody
    </h3>
    <app-agreements-data-preview [application]='application'>
    </app-agreements-data-preview>
    <br>
    <h3>
      Załączniki
    </h3>
    <app-attachments-data-preview [application]='application'>
    </app-attachments-data-preview>
  </div>
}
